import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/medical-history/`;

export const medicalHistory = {
  get: () => generateApiPath(pathBase),
};
